export default __webpack_public_path__ + "static/media/alert.9430364a.svg";